// Whether a call should have a recording that has not come (D-175): every call that connected, in a company whose phones
// send recordings. "waiting" until its phone has synced well after the call (its recording comes with that sync);
// "missing" once it has and none came, usually because call recording is off on that phone. Pure; tested.

/** Ten minutes after the call: by then a sync has had the recording file in hand. */
const SETTLE_MS = 10 * 60_000;

export function recordingDue(
  call: { started_at: string; duration_s: number | null; call_status: string | null },
  lastSyncAt: string | null,
): "waiting" | "missing" | null {
  if (!call.duration_s || call.duration_s <= 0 || call.call_status !== "connected") return null;
  const end = Date.parse(call.started_at) + call.duration_s * 1000;
  return lastSyncAt && Date.parse(lastSyncAt) > end + SETTLE_MS ? "missing" : "waiting";
}
